import React from 'react'

import styled, { useTheme } from 'styled-components/native'

import { PressableOpacity } from '../../atoms/pressableOpacity/PressableOpacity'

type DataTablePaginationProps = React.ComponentProps<typeof PressableOpacity> & {
  isActive?: boolean
}

const PaginationButton = styled(PressableOpacity)<{ isActive?: boolean }>(({ theme, isActive }) => ({
  height: '32px',
  width: '32px',
  borderRadius: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isActive ? theme.colors.backgroundActive : theme.colors.backgroundPrimary,
}))

export const DataTablePaginationButton: React.FC<DataTablePaginationProps> = ({ isActive, ...props }) => {
  const theme = useTheme()
  return (
    <PaginationButton
      isActive={isActive}
      hoveredBackgroundColor={
        isActive ? theme.colors.primaryButtonBackgroundHover : theme.colors.tertiaryButtonBackgroundHover
      }
      pressedBackgroundColor={
        isActive ? theme.colors.primaryButtonBackgroundPressed : theme.colors.tertiaryButtonBackgroundPressed
      }
      disabledBackgroundColor={
        isActive ? theme.colors.primaryButtonBackgroundInactive : theme.colors.tertiaryButtonBackgroundInactive
      }
      {...props}
    />
  )
}
